import { v4 as uuid } from 'uuid';
import { isEmpty } from './assertion.utils';

export interface IRandomNumberOptions {
  length: number;
}

/**
 * @description
 * generates an arbitrary number which value is between a range of min & max
 * @param min the minimum range value
 * @param max the maximum range value
 * @returns a number restricted to { min < result < max }
 */
export function randomNumber(
  min: number = null,
  max: number = null,
  options: IRandomNumberOptions = { length: 10 }
): number {
  let minRange = min;
  let maxRange = max;

  const { length } = options;

  if (isEmpty(minRange) && !isEmpty(maxRange)) {
    throw new Error(`Can't generate a random number without min range parameter`);
  }

  if (!isEmpty(minRange) && isEmpty(maxRange)) {
    throw new Error(`Can't generate a random number without max range parameter`);
  }

  if (isEmpty(minRange) && isEmpty(maxRange)) {
    minRange = +('1' + '0'.repeat(length - 1));
    maxRange = +('9' + '9'.repeat(length - 1));
  }

  return Math.floor(Math.random() * (+maxRange - +minRange + 1) + +minRange);
}

/**
 * @description
 * generates a globally unique identifier string
 * example: '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
 * @returns a guid string
 */
export type Guid = `${string}-${string}-${string}-${string}-${string}`;

export function generateGuid(): Guid {
  return uuid() as Guid;
}

export function isGuid(value: string): value is Guid {
  const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return guidPattern.test(value);
}
